export default __webpack_public_path__ + "static/centralized-platform-dark-f2d6ef68c32d0d25abfb3059611d951c.svg";